<script setup lang="ts">
// TYPES
type LayoutColumns = '3' | '4';

// PROPS
const { layoutColumns } = defineProps({
    image: { type: String, required: true },
    layoutColumns: { type: String as PropType<LayoutColumns>, default: '3' },
    collapseImage: { type: Boolean, default: false },
});

// DATA
const containerGridCols = computed(() => (layoutColumns === '3' ? 'lg:grid-cols-3' : 'lg:grid-cols-4'));
const contentColSpan = computed(() => (layoutColumns === '3' ? 'lg:col-span-2' : 'lg:col-span-3'));
</script>

<template>
    <BaseWidthContainer>
        <div class="flex flex-col gap-8 lg:grid" :class="containerGridCols">
            <img
                :src="image"
                alt=""
                :class="collapseImage && 'hidden'"
                role="presentation"
                class="aspect-square w-full rounded-xl md:hidden lg:inline"
            />
            <div class="flex" :class="contentColSpan">
                <slot />
            </div>
        </div>
    </BaseWidthContainer>
</template>
